module.exports = require('./jstransform');


//////////////////
// WEBPACK FOOTER
// ./~/jsx-control-statements/index.js
// module id = 3202
// module chunks = 0